
// Exchange rates where USD = 1
// Update these values to change currency conversions on the pricing page
export const EXCHANGE_RATES: Record<string, number> = {
  USD: 1,
  EUR: 0.8489,
  GBP: 0.7518,
  AUD: 1.4133,
};

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '\u20AC',
  GBP: '\u00A3',
  AUD: '$',
};

export const CURRENCY_LABELS: Record<string, string> = {
  EUR: 'Euros',
  USD: 'USD',
  GBP: 'GBP',
  AUD: 'AUD',
};
